// @ts-ignore
import AxiosErrorHandler from '@/error-handling/AxiosErrorHandler';
import api from '../API';

export default new AxiosErrorHandler(api);
